import { createRouter, createWebHistory } from 'vue-router';
import reminders from '../views/Reminders';
import { authService } from '@/services/auth-service';

const routes = [
	{
		path: '/',
		name: 'reminders',
		component: reminders,
		meta: {
			requiresAuth : true,
      title: "Reminders"
		},
	},
	{
		path: '/login',
		name: 'login',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
		import(/* webpackChunkName: "about" */ '../views/LoginView.vue'),
    meta: {
      requiresAuth: false,
      navBar: false,
    },
	},
  {
		path: "/state",
		component: () => import("../views/State"),
		meta: {
			requiresAuth : true,
      title: "Select a State",
      search: true,
		},
	},
	{
		path: "/leads/:state",
		component: () => import("../views/Leads"),
		meta: {
			requiresAuth : true,
      title: "Leads",
      search: true,
      statusSelection: true
		},
	},
	{
		path: "/log",
		component: () => import("../views/Log"),
    meta: {
			requiresAuth : true,
      title: "Call Log",
    },
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
});

router.beforeEach(async (to, from, next) => {
	const user = authService.user;

	if (!user && to.matched.some(( record ) => record.meta.requiresAuth)) {
		next("/login");
		return;
	}
	next();
});

export default router;
